import { oc } from '@orpc/contract';
import { targetSchema, updateTargetInputSchema } from '../schemas/targets.schemas.js';
export const updateTargetContract = oc
    .route({
    method: 'PATCH',
    path: '/targets/{id}',
    tags: ['Targets'],
    summary: 'Update a target (value, period, links, deactivate/reactivate); same rules as create (ADMIN, PM)',
})
    .input(updateTargetInputSchema)
    .output(targetSchema);
//# sourceMappingURL=update-target.contract.js.map